import {mapActions, mapGetters, mapMutations} from 'vuex';
import Item from '../../components/list-item/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import datepickerEvent from '../../components/datepicker/index.vue'
import moment from 'moment'
import {seo} from '@/mixins/seo'

export default {
    name: 'events',
    mixins: [seo],
    components: {
        Item,
        HeadFilter,
        BtnLoadMore,
        datepickerEvent
    },
    created() {
        this.seo.title = this.$t('events')
    },
    computed: {
        ...mapGetters({
            list: 'events/list',
            listLength: 'events/listLength',
            isLoading: 'events/isLoading',
        })
    },
    methods: {
        ...mapActions({
            fetchList: 'events/GET_LIST',
        }),
        ...mapMutations({
            setList: 'events/SET_LIST',
        }),
        formattedDate(date) {
            return moment(date).format('dd, DD MMM')
        }
    }
}
